// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qWx_","colBig":"styles_colBig__EdW3d","colSmall":"styles_colSmall__1upaW","shopifyNameWrapper":"styles_shopifyNameWrapper__29qHj"};